import { ColumnId } from "../../../components/OrderPageWidgets/OrderTable/components/ModelTable/columns";
import makeTable from "../makeTable";

import { initialSortMethod, initialWidths } from "./data";

const allIds = Object.values(ColumnId);

const hiddenColumns = [ColumnId.TransportationType];

const defaultIds = allIds.filter((id) => !hiddenColumns.includes(id));

const orderLive = makeTable({
	allIds,
	defaultIds,
	i18tPath: (id) => {
		let transmutationText: string = id;

		if (id === ColumnId.TimeToDelivery) {
			transmutationText = "timeLeft";
		}

		return `tableColumns.orders.${transmutationText}`;
	},
	initialSortMethod,
	initialWidths,
});

export default orderLive;
